class MetaPixel {
    trackCustom(event: string, data: Record<string, any>) {
        // @ts-ignore
        fbq('track', event, data);
    }
}

export default new MetaPixel();